import { Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import React from 'react';
import {
    INotificationReceipt,
    NotificationReceiptStatus
} from 'components/notification/models/NotificationReceipt';
import { StatusCell, StatusColorMap } from 'ui/table/StatusCell';

const colorMap: StatusColorMap = {
    [NotificationReceiptStatus.ERROR]: 'red',
    [NotificationReceiptStatus.SKIPPED]: 'yellow'
};

// If we have a more friendly error message, it should be added here
// These should be lower-cased keys as all messages are checked with toLowerCase
const receiptStatusText: { [key: string]: string } = {
    // SKIPS
    'marketing opt out': 'The Customer opted out of marketing messages',
    'no device token': 'The Customer did not have a valid device token', // App Uninstalled?

    // ERRORS
    notregistered: 'The Customer was previously unregistered',
    'unrecognised token': 'The Customer did not have a valid token'
};

interface NotificationReceiptStatusCellProps {
    row: INotificationReceipt;
}

const NotificationReceiptStatusCell: React.FC<NotificationReceiptStatusCellProps> = ({ row }) => {
    const popover = React.useMemo(() => {
        if (row.status === NotificationReceiptStatus.ERROR) {
            return receiptStatusText[row.errorMessage.toLowerCase()] || row.errorMessage;
        }
        if (row.status === NotificationReceiptStatus.SKIPPED) {
            return receiptStatusText[row.skipMessage.toLowerCase()] || row.skipMessage;
        }
    }, [row]);

    return (
        <Tooltip title={popover} placement="left">
            <span>
                <StatusCell value={row.status} colorMap={colorMap} defaultColor="green" />
            </span>
        </Tooltip>
    );
};

export const renderNotificationReceiptStatusCell = (params: GridRenderCellParams) => (
    <NotificationReceiptStatusCell row={params.row} />
);
